<template>
  <!-- 项目 - 现场预警 -->
  <div class="main-box">
    <div style="margin-top: 4vh"></div>
    <div class="topBody">
      <div class="projectList">
        <el-select v-model="xmId" placeholder="切换项目">
          <el-option
            v-for="(item, index) in projectList"
            :key="index"
            :value="item.projectId"
            :label="item.name"
          >
          </el-option>
        </el-select>
      </div>
      <el-button type="primary" @click="queryFun">查询</el-button>
    </div>
    <div class="box1">
      <div class="box1-l">
        <div class="box1-l-title"><p style="float:left">数据统计</p>     
            <div style="float:right;margin-top:-5px;margin-right:1vw"> <el-date-picker :clearable="false" v-model="lftTime" type="year" value-format="yyyy"
              @change="topLiftChange" placeholder="选择年份" style="height:100%" size="mini">
            </el-date-picker></div></div>
  
        <div class="weekInfo" id="weekInfo"></div>
      </div>
      <div class="box1-r">
           <div class="box1-l-title"><p style="float:left">年度数据统计</p>     
            <div style="float:right;margin-top:-5px;margin-right:1vw"> <el-date-picker :clearable="false" v-model="topRightTime" type="year" value-format="yyyy"
              @change="topRightChange" placeholder="选择年份" style="height:100%" size="mini">
            </el-date-picker></div></div>
        <div class="yearInfo" id="yearInfo"></div>
      </div>
    </div>
    <div class="box2">
      <div class="head-box">
        <div></div>
        <div class="r-input">
          <span style="font-size: 14px; margin-left: 10px; margin-right: 5px"
            >预警类型名称：</span
          >
          <div style="width: 200px; display: flex">
            <el-input
              v-model="search.alarmEventName"
              placeholder="请输入"
              clearable
            >
            </el-input>
          </div>
          <span style="font-size: 14px; margin-left: 10px; margin-right: 5px"
            >预警时间：</span
          >
          <div style="width: 200px; display: flex">
            <el-date-picker
              v-model="search.alarmDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              style="margin-right: 2vw"
            >
            </el-date-picker>
          </div>
          
           <el-button type="primary" @click="dofilter">查询</el-button>
        </div>
      </div>
      <div class="cont-box">
        <div
          class="cont-box-item"
          v-for="(item, index) in listData"
          :key="index"
        >
          <el-image
            class="item1"
            :src="item.photoUrl"
            :preview-src-list="[item.photoUrl]"
          ></el-image>
          <div class="item2">
            <div class="item2-title">{{ item.alarmEventName }}</div>
            <!-- <div class="item2-lab">处理状态：
                    <span class="red" v-if="item.processStatus=='0'">未处理</span>
                    <span class="lv" v-else>已处理</span></div>
                <div class="item2-lab">发现地点：<span style="color:#666666;">{{item.channelName}}</span></div> -->
            <div class="item2-lab">
              发生时间：<span style="color: #666666">{{
                item.createDate
              }}</span>
            </div>
          </div>
          <!-- <div class="item3">
                <div class="item3-lab">处理人：<span  style="color:#666666;">1</span></div>
                <div class="item3-lab">处理方式：<span style="color:#666666;">2</span></div>
                <div class="item3-lab">处理信息：<span style="color:#666666;">3</span></div>
            </div> -->
            <!-- <div class="item4">
                <div class="item3-lab">项目负责人：<span style="color:#666666;">4</span></div>
                <div class="item3-lab">联系方式：<span style="color:#666666;">5</span></div>
                <div class="item3-lab"></div>
            </div> -->
        </div>
      </div>
      <div class="fenye-b"></div>
      <div class="fenye">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItems"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import base from '../../../untils/base'
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
export default {
  data() {
    return {
      lftTime: '',
      topRightTime:'',
      xmName: '',
      xmId: '',
      projectList: [],
      search: {
        alarmEventName: '',
        alarmDate: '',
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      types: [],
      statusList: [
        { label: '已处理', value: '0' },
        { label: '未处理', value: '1' },
      ],
      currentPage: 1,
      pageSize: 20,
      totalItems: 0,
      groupId: '',
      seachTime: ['', ''],
      listData: [], //列表
      noData: false, //是否有数据
      dialogTitle: '预警详情', //
      handleVisible: false,
      form: {
        //预警处理
        handlerName: '',
        handlerId: '',
        status: '0',
        handlerMsg: '',
        processMode: '',
      },
      infoVisible: false, //详情弹出框
      info: {
        //详情信息
      },
      typeList: {
        type1: '未带安全帽',
        type2: '人员聚集',
        type3: '越界',
        type4: '车位',
        type6: '未系安全带',
        type7: '明火烟雾',
        type8: '闯入',
        type9: '脱岗',
        type10: '未穿反光衣',
      },
    }
  },
  mounted() {
    this.topRightTime=util.myTime.getYear()+''
    this.lftTime= util.myTime.getYear()+''
    this.groupId = util.session.get('groupId')
    this.selectEnterpriseNumber() //获取项目
    // this.seachTime = util.myTime.getCurWeek()

    this.search.alarmDate = util.myTime.getCurTime()
    this.getTypeList()
    // this.getData()
    // this.selectAiWarningYearCount()
    // this.selectAiWarningWeekCount()
  },
  methods: {
    endXmId(item) {
      console.log(item)
    },
    // 根据项目查询
    queryFun() {
      console.log(this.xmId)
      // 折线图
      this.selectAiWarningWeekCount()
      //  饼图
      this.selectAiWarningYearCount()
      //  列表
      this.getData()
    },
    // 获取公司下的项目列表
    async selectEnterpriseNumber() {
      // this.projectId = '1579401099549286402'
      // this.xmId = '1579401099549286402'
      // this.selectAiWarningWeekCount()
      // this.selectAiWarningYearCount()
      // this.getData()
      const data = await myHttp.selectEnterpriseNumber({
        groupId: this.groupId,
      })

      if (data.data.code == 200) {
        const list = data.data.data.message
        this.projectList = list
        console.log('公司下的项目列表====》', this.projectList)
        this.xmId = this.projectList[0].projectId
        console.log(this.xmId)
        // this.projectId = '1579401099549286402'
        // this.xmId = '1579401099549286402'
        this.selectAiWarningWeekCount()
        this.selectAiWarningYearCount()
        this.getData()
        this.findYearTimeCameraWaringList()
      }
    },
    // 预警周统计
    selectAiWarningWeekCount() {
      let that = this
      myHttp.findYearTimeCameraWaringList({
          projectId: this.xmId,
          time:this.lftTime
          // startTime: util.myTime.getWeekDateWai().start,
          // endTime: util.myTime.getWeekDateWai().end,
        })
        .then((res) => {
          console.log('结果1', res)
          if (res.data.code === 200) {
            let tiem = []
            let listS = []
            let data = res.data.data.findYearTimeCameraWaringList
 || []
            console.log('处理后的月数据----》',data);
            let type = [] // 获取所有类型
            if (data.length > 0 && data[0].warning.length > 0) {
              for (let i = 0; i < data[0].warning.length; i++) {
                let obj = {}
                obj.type = data[0].warning[i].alarmEventType 
                obj.name = data[0].warning[i].alarmEventName
                console.log(obj);
                type.push(obj)
              }
            }
            console.log('type--->',type);
            let arr = []
            if (data.length > 0) {
              for (let i = 0; i < data.length; i++) {
                arr.push(data[i].warning)
                tiem.push(data[i].warning[0].day)
              }
            }
            let arr1 = arr.flat(10)
            console.log(arr1)
            for (let i = 0; i < type.length; i++) {
              let data5 = []
              for (let j = 0; j < arr1.length; j++) {
                if (type[i].type == arr1[j].alarmEventType) {
                  data5.push(arr1[j].count)
                }
              }
              let obj = {
                smooth: true,
                name: type[i].name,
                type: 'line',
                // stack: 'Total',
                data: JSON.parse(JSON.stringify(data5)),
              }
              listS.push(JSON.parse(JSON.stringify(obj)))
            }
            console.log(listS)
            that.ehcartsWeek(tiem, listS)
          } else {
            this.$message.error(res.data.msg)
          }
          console.log(res)
          // if(res.data.code==200){
          //     let list = res.data.data.data
          //     let tiem = res.data.data.time
          //     let listS = []
          //     let nameList = []
          //     list.forEach((item,index)=>{
          //         for(let key in item){
          //             let a = {
          //                 smooth:true,
          //                 name: `${that.typeList[key]}`,
          //                 type: 'line',
          //                 stack: 'Total',
          //                 data: item[key]
          //             }
          //             let b = `${that.typeList[key]}`
          //             listS.push(a)
          //             nameList.push(b)
          //         }
          //     })
          //     console.log(listS)
          //     that.ehcartsWeek(tiem,listS,nameList)
          // }
        })
    },
    // 周统计图
    ehcartsWeek(date, listData, name) {
            this.$echarts.init(document.getElementById('weekInfo')).dispose();
      let chartDom1 = document.getElementById('weekInfo')
      let myChart1 = this.$echarts.init(chartDom1)

      myChart1.setOption({
        tooltip: {
          trigger: 'axis',
          // position:['85%',10]
          textStyle: {
            align: 'left',
          },
        },
        width: '83%',
        legend: {
          orient: 'vertical',
          // data: name,
          right: '0',
          top: '10%',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '12%',
          containLabel: true,
        },

        color: [
          '#0D3A95',
          '#2C60C8',
          '#95B3F0',
          '#7385A8',
          '#6272D8',
          '#27437C',
          '#698FDB',
          '#01739F',
          '#278E9F',
        ],
        xAxis: {
          axisLine: {
            lineStyle: {
              type: 'solid',
              color: '',
              width: '1',
            },
          },
          type: 'category',
          splitLine: {
            show: true, //让网格显示
            lineStyle: {
              //网格样式
              color: ['#07DBFF'], //网格的颜色
              width: 1, //网格的宽度
              type: 'dashed', //网格是实实线，可以修改成虚线以及其他的类型
            },
          },
          splitLine: {
            show: true, //让网格显示
            lineStyle: {
              //网格样式
              color: ['#07DBFF'], //网格的颜色
              width: 1, //网格的宽度
              type: 'dashed', //网格是实实线，可以修改成虚线以及其他的类型
            },
          },
          boundaryGap: false,
          data: date,
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              color: ['#07DBFF'],
              width: 1,
              type: 'dashed',
            },
          },
        },
        series: listData,
      })
    },
    // 预警年统计
    selectAiWarningYearCount() {
      let that = this
      myHttp
        .findEveryQuarterCameraWaringList({
          projectId: this.xmId,
          year: this.topRightTime,
        })
        .then((res) => {
          console.log(res, '结果')
          if (res.data.code == 200) {
            let item = [
              {
                value: res.data.data.everyQuarterCameraWaringList[0].count,
                name: '第一季度',
              },
              {
                value: res.data.data.everyQuarterCameraWaringList[1].count,
                name: '第二季度',
              },
              {
                value: res.data.data.everyQuarterCameraWaringList[2].count,
                name: '第三季度',
              },
              {
                value: res.data.data.everyQuarterCameraWaringList[3].count,
                name: '第四季度',
              },
            ]
            // that.echartsYear(item)
            that.echaTopRight(item)
          }
        })
    },
    //年统计图
    echartsYear(itemSt) {
            this.$echarts.init(document.getElementById('yearInfo')).dispose();
      let chartDom = document.getElementById('yearInfo')
      let myChart = this.$echarts.init(chartDom)
      myChart.setOption({
        color: ['#0d3a95', '#4d7bd8', '#8394b5', '#34579d'],
        series: [
          {
            label: {
              show: true,
              position: 'inner',
              formatter: '{b}{d}%',
            },
            name: 'Nightingale Chart',
            type: 'pie',
            // radius: [0, 150],
            // center: ['50%', '50%'],
            // roseType: 'area',
            itemStyle: {
              borderRadius: 0,
            },
            data: itemSt,
          },
        ],
      })
    },
    //获取事件类型
    getTypeList() {
      var that = this
      myHttp.getTopicValueList().then(
        function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.aiEquipCameraTopics || []
            that.types = list
          } else {
            that.$message.error(resp.data.msg)
          }
        },
        function () {}
      )
    },
    //条件过滤
    dofilter() {
      this.currentPage = 1
      this.pageSize = 20
      this.getData()
    },
    //时间过滤
    timefilter() {
      this.getData()
    },
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    getData() {
      this.search.projectId = this.xmId
      this.search.pageSize = this.pageSize
      this.search.pageNum = this.currentPage
      myHttp.getEquipCameraWaringPhoto(this.search).then((resp) => {
        console.log(resp)
        if (resp.data.code == '200') {
          var list = resp.data.data.pageInfo.list || []
          this.totalItems = resp.data.data.pageInfo.total
          for (let i = 0; i < list.length; i++) {
            const element = list[i]
            element.photoUrl = base.httpCtx + element.photoUrl
          }
          this.listData = list
        }
      })
    },

    //根据id去图片
    getImgById(id) {
      var list = [
        {
          id: '1311197740306268161',
          url: require('../../../assets/image/guifan_files/15.png'),
        },
        {
          id: '1311197469643636738',
          url: require('../../../assets/image/guifan_files/chuangru.jpg'),
        }, //闯入
        {
          id: '213123213213213',
          url: require('../../../assets/image/guifan_files/fangaungy.png'),
        },
        {
          id: '324243243242',
          url: require('../../../assets/image/guifan_files/yuejie.png'),
        }, //越界
        {
          id: '324241113243242',
          url: require('../../../assets/image/guifan_files/yanwu.jpeg'),
        }, //明火/烟雾
        {
          id: '7909338795646ew',
          url: require('../../../assets/image/guifan_files/jiank.jpg'),
        }, //监控室脱岗
      ]
      var url = ''
      for (var i = 0; i < list.length; i++) {
        if (list[i].id == id) {
          url = list[i].url
        }
      }
      return url
    },

    //处理弹出框
    toUpdata(row) {
      this.form.id = row.warningId
      this.form.handlerName = util.session.get('user').name
      this.form.handlerId = util.session.get('user').id
      this.form.processMode = ''
      this.form.handlerMsg = ''
      this.handleVisible = true
    },
    //处理
    modSubmit() {
      var that = this
      myHttp.updateAiEquip(this.form).then(function (resp) {
        if (resp.data.code == '200') {
          that.handleVisible = false
          that.getData()
          that.$message.success('处理成功')
        } else {
          that.$message.error(resp.data.msg)
        }
      })
    },
    //展示内容
    showInfo(row) {
      //var that = this
      this.info = row
      this.infoVisible = true
    },
    //取消预警
    cancel(row) {
      var that = this
      this.$confirm('此操作将永久取消预警, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          myHttp
            .deleteAiEquipCameraWarning({
              id: row.warningId,
            })
            .then(function (resp) {
              if (resp.data.code == '200') {
                that.$message({
                  type: 'success',
                  message: '取消成功!',
                })
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
        })
        .catch((err) => {})
    },
    echaTopRight(item) {
      this.$echarts.init(document.getElementById('yearInfo')).dispose();
      let chartDom = document.getElementById('yearInfo')
      let myChart = this.$echarts.init(chartDom)
      // yearInfo
      let pieColors = ['#5470c6', '#6AACF4', '#8EC2DA', '#6DCCE2']
      let richColor = {}
      pieColors.forEach((item, idx) => {
        richColor[`color${idx}`] = {
          fontSize: 10,
          color: item,
        }
      })

      let chartData = item

      let option = {
        color: pieColors,
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['36%', '56%'],
            center: ['60%', '50%'],
            avoidLabelOverlap: false,
            label: {
              formatter: (params) => {
                // console.log(params)
                return `{color${params.dataIndex}|${params.name}(${params.value})}`
              },
              rich: richColor,
            },
            labelLine: {
              lineStyle: {
                width: 3,
              },
            },
            data: chartData,
          },
          {
            // name: '数据总数',
            type: 'pie',
            radius: ['0%', '0%'],
            center: ['60%', '50%'],
            itemStyle: {
              // 防止鼠标悬浮到标签时出现放大的点
              color: 'transparent',
            },
            label: {
              position: 'inside',
              // formatter: `{data|{c}}\n{serie|{a}}`,
              rich: {
                data: {
                  fontWeight: 'bold',
                  fontSize: 20,
                  color: `#202020`,
                  lineHeight: 68,
                  textBorderColor: `transparent`,
                  textBorderWidth: 0,
                },
                serie: {
                  fontSize: 24,
                  color: `#acbac6`,
                  lineHeight: 28,
                  textBorderColor: `transparent`,
                  textBorderWidth: 0,
                },
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              // 计算表格数据value总和
              chartData.reduce((prev, cur) => prev + cur.value, 0),
            ],
          },
        ],
      }
      myChart.setOption(option)
    },
    // 获取左侧图表数据
    async findYearTimeCameraWaringList(){
const data = await myHttp.findYearTimeCameraWaringList({projectId:this.xmId,
time:this.lftTime
})
console.log('左侧图表所需数据---》',data);
    },
    // 左侧图时间更新
    topLiftChange(){
      console.log(this.lftTime);
      this.selectAiWarningWeekCount()},
     // 右侧图时间更新
    topRightChange(){this.selectAiWarningYearCount()}
  },
}
</script>

<style scoped>
.main-box {
  width: 100%;
  height: 100%;
  position: relative;
  /* padding: 1vw; */
  background: #ecf0f5;
  overflow: auto;
  padding-left: 8px;
  padding-right: 24px;
}
.head-box {
  width: 100%;
  height: 6vh;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  border-bottom: 2px solid #e7e7e7;
  padding-left: 1vw;
}
.head-box * {
  /* margin-right: 1vw; */
  font-family: SourceHanSansCN-Regular;
  font-size: 15px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #666666;
}
.table-box {
  width: 100%;
  height: calc(100% - 14vh);
  position: relative;
  padding: 1vh 0;
  overflow: auto;
}
.table-item {
  width: 100%;
  height: 16vh;
  padding: 2vh 2vh 0;
  position: relative;
  border-bottom: 1px solid #f2f2f2;
  display: flex;
}
.table-item-con {
  width: calc(33.33% - 12vh);
  height: 100%;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  align-items: center;
  padding-left: 4vw;
}
.table-item-btn {
  width: 20vh;
  height: 100%;
  position: relative;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  justify-items: center;
}
.table-item-con .title {
  width: 100%;
  height: 4vh;
  color: #993300;
  font-size: 1vw;
  position: relative;
  line-height: 4vh;
}
.table-item-con .lable {
  width: 100%;
  height: 3vh;
  position: relative;
}
.table-item-con p {
  text-align: left;
}
.flex-center {
  display: flex;
  justify-content: center;
  justify-items: center;
}

/* .scene-dialog{
        width:100
    } */
.scene-dialog .head1 {
  width: 100%;
  height: 27vh;
  padding: 0 1vh;
  margin-bottom: 3vh;
  position: relative;
  display: flex;
}
.box1 {
  margin-top: 26px;
  height: 41vh;
  display: flex;
}
.box1-l {
  width: 62vw;
  height: 100%;
  border-radius: 6px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.box1-l-title {
  line-height: 6vh;
  height: 6vh;
 
  justify-content: start;
  align-items: center;
  padding-left: 18px;
  border-bottom: 2px solid #e7e7e7;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #666666;
}
.box1-r {
  flex: 1;
  margin-left: 8px;
  border-radius: 6px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.box1-r-title {
  height: 6vh;
  display: flex;
  justify-content: start;
  align-items: center;
  padding-left: 18px;
  border-bottom: 2px solid #e7e7e7;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #666666;
}
.box2 {
  position: relative;
  margin-top: 8px;
  margin-bottom: 10px;
  height: 81.5vh;
  border-radius: 6px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.cont-box {
  height: 67vh;
  margin-top: 1.5vh;
  overflow: auto;
  padding: 0 0.43vw;
}
.cont-box-item {
  height: 15.8vh;
  border-radius: 6px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(77, 110, 177, 0.3);
  margin-bottom: 1.1vh;
  padding: 0 0.85vw 0 1.09vw;
  display: flex;
  align-items: center;
}
.item1 {
  width: 6vw;
  height: 13.2vh;
  border-radius: 6px;
}
.item2 {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-around;
  text-align: start;
  margin-left: 2.7vw;
  width: 24vw;
}
.item2-title {
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #d21b1b;
}
.item2-lab {
  color: #9e9e9e;
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0em;
}
.item3 {
  padding-top: 5.3vh;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-around;
  text-align: start;
  width: 20vw;
}
.item3-lab {
  color: #9e9e9e;
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0em;
}
.item4 {
  padding-top: 5.28vh;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-around;
  text-align: start;
  width: 20vw;
}
.item4-lab {
  color: #9e9e9e;
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0em;
}
.item5 {
  padding-top: 1.29vh;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  margin-left: 5vw;
}
.btn {
  width: 3.3vw;
  height: 3.2vh;
  border-radius: 6px;
  background: #fdfefe;
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #666666;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1vh;
}
.btn:hover {
  cursor: pointer;
  opacity: 0.7;
}
.fenye-b {
  height: 6vh;
  position: absolute;
  left: 0;
  bottom: 0;
}
.fenye {
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  border-radius: 0px 0px 6px 6px;
  background: #ffffff;
  box-shadow: 6px 0px 10px 0px rgba(197, 197, 197, 0.3);
}
.red {
  color: #d21b1b !important;
}
.lv {
  color: #10b33b !important;
}
.yearInfo {
  width: 25.38vw;
  height: 38vh;
}
.weekInfo {
  width: 61.92vw;
  height: 38vh;
}
.r-input {
  width: 36vw;
  display: flex;
  align-items: center;
}
.topBody {
  width: 100%;
  height: 60px;
  border-radius: 6px;
  opacity: 1;

  background: #ffffff;

  box-shadow: 5px 4px 10px -2px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
}
.projectList {
  width: 11.4583vw;
  margin-right: 1.5625vw;
  margin-left: 0.8333vw;
}

</style>
<style>
@import '../../../assets/css/common.css';

</style>
<style>
  .r-input span{
color: #ecf0f5;
  }
</style>
